import React from 'react'
import { Button } from 'reactstrap';
import { DeleteReturnReason } from './DeleteReturnReason';
import { FormReturnReason } from './FormReturnReason';
import { Dialog } from 'primereact/dialog';

export const ModalReturnReason = (props) => {

    const {
        method, modalTitle, loading, modal, toggle,
        handleInputChange, saveDelete, saveCreate, saveUpdate,
        id_return_reason, reason, validaciones, is_sample,
        is_work_order, is_tracking, is_send

    } = props;

    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>

            <Button
                color="secondary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
            >
                Confirmar
            </Button>
            <Button
                color="danger"
                size="sm"
                onClick={toggle}
            >
                Cancelar
            </Button>
        </div>
    );

    return (
        <Dialog
            // header={"Catalógo de devoluciones"}
            visible={modal}
            onHide={toggle}
            closable={false}
            modal
            blockScroll
            //className='medium-dialog'
            footer={footer}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="fa fa-book f-24"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Catalógo de devoluciones
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v2`}



        >

            {
                method === "create"
                    ? <FormReturnReason
                        button="Guardar"
                        {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveCreate, is_sample, is_work_order, is_tracking, is_send }}
                    />
                    : (method === "update")

                        ?
                        <FormReturnReason
                            button="Actualizar"
                            {...{
                                toggle, loading, handleInputChange, id_return_reason, reason, validaciones, methodAction: saveUpdate, is_sample, is_work_order, is_tracking, is_send
                            }}
                        />
                        :
                        // <DeleteReturnReason
                        //     {...{ toggle, loading, saveDelete, reason }}
                        // />
                        null


            }
        </Dialog>

    )
}
